import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import {
  fetchCurrentMember as fetchCurrentMemberServer,
  addMemberToOrganization as addMemberToOrganizationServer,
  deleteMemberFromOrganization as deleteMemberFromOrganizationServer,
  changeMemberRole as changeMemberRoleServer,
} from '@/actions/members';

export const fetchCurrentMember = async () => {
  const userAccessToken = await getUserAccessToken();
  return await fetchCurrentMemberServer(userAccessToken);
};

export const addMemberToOrganization = async (data: any) => {
  const userAccessToken = await getUserAccessToken();
  return await addMemberToOrganizationServer(userAccessToken, data);
};

export const changeMemberRole = async (memberId: string, role: string, enabled: boolean) => {
  const userAccessToken = await getUserAccessToken();
  return await changeMemberRoleServer(userAccessToken, memberId, role, enabled);
};

export const deleteMemberFromOrganization = async (memberId: string) => {
  const userAccessToken = await getUserAccessToken();
  return await deleteMemberFromOrganizationServer(userAccessToken, memberId);
};
